import { Builder } from '@builder.io/react'
import React from 'react'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  contentText: string
  textAlignment: Alignment
  roundedBorder: boolean
  horizontalPadding: boolean
  verticalPadding: boolean
  belowNavbar: boolean
  customMaxWidth: boolean
}

const Paragraph = ({
  backgroundColor,
  contentText,
  textAlignment,
  roundedBorder,
  horizontalPadding,
  verticalPadding,
  belowNavbar,
  customMaxWidth = false
}: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  return (
    <div
      className={`relative overflow-hidden bg-white py-4 md:w-full ${roundedBorder ? 'rounded-3xl' : ''} ${
        horizontalPadding ? 'my-6' : ''
      } ${verticalPadding ? 'w-11/12 mx-auto' : 'w-full'} ${belowNavbar ? 'lg:-mt-12 lg:pt-12' : ''}`}
      style={{ backgroundColor }}
    >
      <div className="relative px-4 sm:px-6">
        <div className={`mx-auto ${customMaxWidth ? 'max-w-7xl' : 'max-w-prose'} text-lg`}>
          <p
            className={`enable-list-styles text-base ${getAlignmentClass()}`}
            dangerouslySetInnerHTML={{ __html: contentText }}
          ></p>
        </div>
      </div>
    </div>
  )
}

export default Paragraph

Builder.registerComponent(Paragraph, {
  name: 'Paragraph',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'roundedBorder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'horizontalPadding',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'verticalPadding',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'belowNavbar',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'customMaxWidth',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
